<script type="text/javascript">
	import Icon from "../icon.svelte";


	export let selected = {};
	export let icon;

	export let label;

	let componentLabel;
	if (label) componentLabel = label;
	else componentLabel = "Не выбрано";
	$:{
		if (selected.label) componentLabel = selected.label;
	}
</script>

<div class="product-dropdown" class:blue={$$props.blue} class:grey={$$props.grey} class:inverse={$$props.inverse}>
	{#if selected.icon}
		<Icon i={selected.icon}/>
	{:else if icon}
		<Icon i={icon}/>
	{:else}
		{#if $$props.blue}
		<Icon i='sq'/>
		{:else}
		<Icon i='game'/>
		{/if}
	{/if}

	<span>{componentLabel}</span>
</div>

<style type="text/css">
	.product-dropdown{
		display: flex;
		align-items: center;
		background: #39DA53;
		border-radius: 4px;
		color: white;
		width: auto;
		padding: 10px 15px;
	}
	.product-dropdown.inverse{
		flex-direction: row-reverse;
	}
	.product-dropdown.inverse > span{
		margin-left: 0;
		margin-right: 10px;
	}
	.product-dropdown.blue{
		background: #267CE1;
	}
	.product-dropdown.grey{
		background: #25253A;
	}
	.product-dropdown > span{
		margin-left: 10px;
	}
</style>